module.exports = __webpack_public_path__ + "img/价格说明表.255be9e6.jpg";